export var PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/calendar/Constants.js
// module id = 653
// module chunks = 0